export type TeamMemberPhoto = {
  src: string;
  width: number;
  height: number;
  alt: string;
};

export type TeamMember = {
  slug: string;
  name: string;
  role: string;
  qualifications?: string[];
  education: string;
  phone: string;
  phoneHref: string;
  mobile?: string;
  mobileHref?: string;
  email?: string;
  photo: TeamMemberPhoto;
};

export const teamMembers: TeamMember[] = [
  {
    slug: "dagmar-grafova",
    name: "Ing. Dagmar Grafová",
    role: "majitelka a jednatelka firmy",
    qualifications: [
      "daňová poradkyně zapsaná u KDP ČR pod ev. číslem 1008",
      "soudní znalkyně ustanovena Krajským soudem v Ostravě",
    ],
    education: "Vysoká škola ekonomická v Bratislavě",
    phone: "553 612 851",
    phoneHref: "tel:+420553612851",
    mobile: "+420 777 612 851",
    mobileHref: "tel:+420777612851",
    email: "poradcegrafova@volny.cz",
    photo: {
      src: "https://dane-a-ucetnictvi.eu/images/dane-a-ucentictvi/ing-dagmar-grafova.jpg",
      width: 200,
      height: 299,
      alt: "Ing. Dagmar Grafová, majitelka a jednatelka firmy, daňová poradkyně a soudní znalkyně",
    },
  },
  {
    slug: "renata-polackova",
    name: "Ing. Renáta Poláčková",
    role: "vedoucí účetního týmu",
    education: "VŠB – TÚ v Ostravě",
    phone: "553 612 851",
    phoneHref: "tel:+420553612851",
    email: "polackova.ucto@seznam.cz",
    photo: {
      src: "https://dane-a-ucetnictvi.eu/images/dane-a-ucentictvi/ing-renata-polackova.jpg",
      width: 200,
      height: 299,
      alt: "Ing. Renáta Poláčková, vedoucí účetního týmu",
    },
  },
  {
    slug: "veronika-kolcunova",
    name: "Veronika Kolcunová",
    role: "asistentka účetní",
    education: "VOŠ Opava",
    phone: "553 612 851",
    phoneHref: "tel:+420553612851",
    photo: {
      src: "https://dane-a-ucetnictvi.eu/images/dane-a-ucentictvi/veronika-ucto.jpg",
      width: 200,
      height: 299,
      alt: "Veronika Kolcunová, asistentka účetní",
    },
  },
];

export function getInitials(name: string): string {
  const withoutTitles = name
    .replace(/\b(Ing\.|Mgr\.|JUDr\.|MUDr\.|Bc\.|MBA)\b/g, "")
    .trim();
  const parts = withoutTitles.split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return `${first}${last}`.toUpperCase();
}

export const owner = teamMembers[0];

export const companyValues = [
  {
    title: "Osobní přístup",
    text: "Ke každému klientovi přistupujeme individuálně a komunikujeme srozumitelně, bez zbytečného úředního jazyka.",
  },
  {
    title: "Odbornost",
    text: "Účetní a daňové otázky řešíme s ohledem na platné předpisy a průběžně se v oblasti vzděláváme.",
  },
  {
    title: "Spolehlivost",
    text: "Hlídáme termíny a povinnosti, abyste na nic důležitého nemuseli myslet sami.",
  },
  {
    title: "Diskrétnost",
    text: "S vašimi údaji pracujeme jako s důvěrnými a nakládáme s nimi v souladu s platnými předpisy.",
  },
];
